<template>
  <div class="dormitory-diagram">
    <el-row style="margin-bottom: 0.5rem">
      <span class="title">{{ $t("app.roomType") }}:</span>
      <color-list
        style="margin-right: 60px"
        :color-list="colorList"
        :value="search.roomType"
        @select="updateRoomType"
      ></color-list>
      <span class="title">{{ $t("app.roomStatus") }}:</span>
      <el-checkbox-group
        style="display: inline-block"
        v-model="search.roomStatus"
      >
        <el-checkbox :label="1">Vacant Clean</el-checkbox>
        <el-checkbox :label="0">Not Vacant Clean</el-checkbox>
      </el-checkbox-group>
    </el-row>
    <el-row style="margin-bottom: 0.5rem">
      <span class="title">{{ $t("app.bedStatus") }}:</span>
      <color-list
        :color-list="colorListSecond"
        :value="search.bed"
        @select="updateBed"
      ></color-list>
    </el-row>
    <el-row style="margin-bottom: 0.5rem">
      <span class="title">{{ $t("app.studentType") }}:</span>
      <color-list
        style="display: inline-block"
        :icon="stuIcon"
        :color-list="colorListThird"
        :value="search.person"
        @select="updatePerson"
      ></color-list>
    </el-row>
    <el-row>
      <span class="title">{{ $t("app.floor") }}:</span>
      <div style="display: inline-block; padding-right: 10px">
        <el-checkbox-group v-model="search.floorList">
          <el-checkbox
            v-for="floor in floorList"
            :key="floor.code"
            :label="floor.code"
            >{{ floor.name }}</el-checkbox
          >
        </el-checkbox-group>
      </div>
      <el-button type="primary" size="small" @click="selectReverse">{{
        $t("app.invertSelect")
      }}</el-button>
    </el-row>

    <span class="text">Room Total: {{ roomTotal }}</span>
    <span class="text">Bed Total: {{ bedTotal }}</span>
    <el-button type="primary" size="small" @click="selectAll">{{
      $t("app.selectAll")
    }}</el-button>
    <el-button
      type="primary"
      size="small"
      style="margin-left: 10px"
      @click="reset"
      >{{ $t("app.reset") }}</el-button
    >
    <el-button
      type="success"
      icon="el-icon-search"
      size="small"
      style="margin: 7px 0 7px 10px"
      :loading="loading"
      @click="searchData"
      >{{ $t("app.search") }}</el-button
    >
    <el-select
      style="margin-left: 10px; width: 100px"
      size="small"
      v-model="selectSort"
      placeholder="樓層排序"
      @change="sortChange"
    >
      <el-option
        v-for="item in floorSort"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      >
      </el-option>
    </el-select>
    <div class="container">
      <el-row
        :gutter="4"
        v-for="floor in data"
        :key="floor.name"
        style="margin-bottom: 15px"
      >
        <h3 style="text-align: center; font-size: 16px">
          {{ floor.name }}
        </h3>
        <el-col
          :xs="10"
          :sm="7"
          :md="5"
          :lg="3"
          :xl="2"
          v-for="room in floor.room"
          :key="room.name"
        >
          <div>
            <!-- @contextmenu.prevent="showRoom(room.name)" -->
            <el-tooltip
              effect="dark"
              :content="
                room.type === '1'
                  ? 'Single,' + room.state
                  : room.type === '2'
                  ? 'Twin,' + room.state
                  : room.type === '3'
                  ? 'Double,' + room.state
                  : room.type === '4'
                  ? 'Suite,' + room.state
                  : ''
              "
              placement="top-start"
            >
              <el-card
                shadow="hover"
                class="room"
                :style="{ 'background-color': room.color }"
              >
                <h4>{{ room.name }}</h4>
                <div>
                  <span v-if="room.bed.length === 0" class="placeholder"></span>
                  <span
                    class="bed"
                    v-for="bed in room.bed"
                    :key="bed.name + room.name + floor.name"
                    :style="{ 'background-color': bed.color }"
                    @contextmenu.prevent.stop="showBed(room.name, bed.name)"
                  >
                    <el-tooltip
                      effect="dark"
                      :content="
                        bed.type === '1'
                          ? 'OOO'
                          : bed.type === '2'
                          ? 'Vacant Clean'
                          : bed.type === '3'
                          ? 'Vacant Dirty'
                          : bed.type === '4'
                          ? 'Occupied'
                          : bed.type === '5'
                          ? 'Occupied / Luggage'
                          : ''
                      "
                      placement="top-start"
                    >
                      <div>
                        <span style="font-size: 12px">{{ bed.name }}</span>
                        <br />
                        <em
                          v-if="bed.student"
                          @dblclick.prevent="showInfo(bed.student)"
                          class="user-icon"
                          :class="stuIcon"
                          :style="{
                            color: bed.student.StudentSpecialTypeColor,
                          }"
                        ></em>
                      </div>
                    </el-tooltip>
                  </span>
                </div>
              </el-card>
            </el-tooltip>
          </div>
        </el-col>
      </el-row>
    </div>
    <el-dialog
      :modal-append-to-body="false"
      :append-to-body="true"
      :visible.sync="visible"
      width="1000px"
      :title="$t('app.details')"
    >
      <div v-if="view === 'info'" style="height: 400px">
        <el-form style="height: 100%; overflow: auto" class="scroll-bar">
          <el-col
            :span="12"
            v-for="(i, index) in stuInfo"
            :key="index"
            style="height: 40px; padding: 0 15px"
          >
            <el-form-item :label="index" style="position: relative">
              <el-input
                v-model="stuInfo[index]"
                style="width: 240px; float: right"
                size="small"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
        </el-form>
      </div>
      <div v-else-if="view === 'room'">
        <el-select
          v-model="roomType"
          :placeholder="$t('app.roomType')"
          style="margin-bottom: 20px; width: 100%"
        >
          <el-option
            v-for="item in roomTypeList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <div v-else>
        <div>
          <el-select
            v-model="bedStatus"
            :placeholder="$t('app.bedStatus')"
            style="width: 100%; margin-bottom: 10px"
          >
            <el-option
              v-for="item in statusList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <el-input
            type="textarea"
            :rows="2"
            placeholder="請輸入狀態變更原因"
            v-model="reason"
          >
          </el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="view = ''" type="info">{{
          $t("app.cancel")
        }}</el-button>
        <el-button size="small" type="primary" @click="handleClose">{{
          $t("app.confirm")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import ColorList from "@/components/tools/ColorCheckList";
// import IconList from "@/components/tools/ColorList";
import {
  getRoomColor,
  getBedColor,
  getPersonColor,
} from "@/api/dormitoryManagement/list";
import { getFloorList } from "@/api/systemManagement/roomManagement";
import {
  getList,
  changeBed,
  changeRoom,
} from "@/api/dormitoryManagement/diagram";
export default {
  components: {
    ColorList,
    // IconList
  },
  data() {
    return {
      statusList: [
        { value: "1", label: "OOO" },
        { value: "2", label: "Vacant Clean" },
        { value: "3", label: "Vacant Dirty" },
        { value: "4", label: "Occupied" },
        { value: "5", label: "Occupied / Luggage" },
      ],
      roomTypeList: [
        { value: "1", label: "Single" },
        { value: "2", label: "Twin" },
        { value: "3", label: "Double" },
        { value: "4", label: "Suite" },
      ],
      roomType: "",
      bedStatus: "1",
      bed: "",
      room: "",
      stuInfo: {},
      view: "",
      loading: false,
      stuIcon: "el-icon-s-custom",
      data: [],
      roomTotal: "",
      bedTotal: "",
      colorList: [],
      colorListSecond: [],
      colorListThird: [],
      floorList: [],
      search: {
        roomType: [],
        roomStatus: [],
        bed: [],
        floorList: [],
        person: [],
      },
      floorSort: [
        {
          value: "0",
          label: this.$t("app.ascOrder"),
        },
        {
          value: "1",
          label: this.$t("app.descOrder"),
        },
      ],
      selectSort: "0",
      reason: "",
    };
  },
  created() {
    this.init();
  },
  computed: {
    visible: {
      get() {
        return this.view === "" ? false : true;
      },
      set() {
        this.view = "";
      },
    },
  },
  methods: {
    selectAll() {
      this.search.roomType = this.colorList.map((item) => {
        return item.code;
      });
      this.search.roomStatus = [1, 0];
      this.search.bed = this.colorListSecond.map((item) => {
        return item.code;
      });
      this.search.floorList = this.floorList.map((item) => {
        return item.code;
      });
      this.search.person = this.colorListThird.map((item) => {
        if (item.code === "") {
          return "''";
        } else {
          return item.code;
        }
      });
    },
    selectReverse() {
      this.search.floorList = this.floorList
        .map((item) => {
          return item.code;
        })
        .filter((_) => this.search.floorList.findIndex((i) => i === _) < 0);
    },
    handleClose() {
      if (this.view === "bed") {
        changeBed({
          RoomIndex: this.room,
          BedCode: this.bed,
          BedState: this.bedStatus,
          ExchangeReason: this.reason,
        }).then(() => {
          this.success();
        });
      } else if (this.view === "room") {
        changeRoom({
          RoomIndex: this.room,
          RoomType: this.roomType,
        }).then(() => {
          this.success();
        });
      } else {
        this.view = "";
      }
    },
    success() {
      this.$message({
        message: this.$t("app.opeSuccess"),
        type: "success",
      });
      this.searchData();
      this.view = "";
    },
    showBed(room, bed) {
      this.view = "bed";
      this.room = room;
      this.bed = bed;
      this.bedStatus = "1";
    },
    showRoom(room) {
      this.view = "room";
      this.room = room;
    },
    showInfo(info) {
      this.view = "info";
      this.stuInfo = JSON.parse(JSON.stringify(info));
      delete this.stuInfo.StudentSpecialTypeColor;
    },
    searchData() {
      this.loading = true;
      getList({
        RoomType: this.search.roomType.join(","),
        RoomState: this.search.roomStatus.join(","),
        BedState: this.search.bed.join(","),
        StudentType: this.search.person.join(","),
        Floor: this.search.floorList.join(","),
        FloorSort: this.selectSort,
      })
        .then((res) => {
          this.loading = false;
          console.log(res.data);
          this.roomTotal = res.data.RoomTotal;
          this.bedTotal = res.data.BedTotal;
          this.data = res.data.FloorGroup.map((floor) => {
            return {
              name: floor.FloorDisplay,
              room: floor.RoomGroup.map((room) => {
                return {
                  name: room.RoomIndex,
                  color: room.RoomTypeColor,
                  type: room.RoomType,
                  state: room.RoomState,
                  bed: room.BedGroup.map((bed) => {
                    return {
                      name: bed.BedCode,
                      color: bed.BedStateColor,
                      student: bed.Student,
                      type: bed.BedState,
                    };
                  }),
                };
              }),
            };
          });
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getFloor() {
      return new Promise((resolve, reject) => {
        getFloorList()
          .then((res) => {
            this.floorList = res.data
              .sort((a, b) => a.FloorCode - b.FloorCode)
              .map((item) => {
                return {
                  code: item.FloorCode,
                  name: item.FloorName,
                };
              });
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    reset() {
      this.search.roomType = [];
      this.search.roomStatus = [];
      this.search.bed = [];
      this.search.person = [];
      this.search.floorList = [];
    },
    updateRoomType(value) {
      this.search.roomType = value;
    },
    updateBed(value) {
      this.search.bed = value;
    },
    updatePerson(value) {
      this.search.person = value;
    },
    getRoomColor() {
      return new Promise((resolve, reject) => {
        getRoomColor()
          .then((res) => {
            this.colorList = res.data.map((item) => {
              return {
                code: item.Code,
                text: item.Text,
                color: item.Color,
              };
            });
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getBedColor() {
      return new Promise((resolve, reject) => {
        getBedColor()
          .then((res) => {
            this.colorListSecond = res.data.map((item) => {
              return {
                code: item.Code,
                text: item.Text,
                color: item.Color,
              };
            });
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getColor() {
      return new Promise((resolve, reject) => {
        getPersonColor()
          .then((res) => {
            this.colorListThird = res.data.map((item) => {
              return {
                code: item.Code,
                text: item.Text,
                color: item.Color,
              };
            });
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    init() {
      Promise.all([
        this.getRoomColor(),
        this.getBedColor(),
        this.getColor(),
        this.getFloor(),
      ]).then(() => {
        this.selectAll();
        this.searchData();
      });
    },
    sortChange() {
      this.searchData();
    },
  },
};
</script>
<style lang="scss" scoped>
.dormitory-diagram {
  height: calc(100% - 80px);
  .title {
    font-size: 14px;
    margin-right: 20px;
    margin-bottom: 20px;
  }
  .container {
    height: calc(100% - 100px);
    overflow: auto;
  }
  .text {
    font-size: 14px;
    font-weight: 600;
    margin-right: 40px;
  }
  .bed {
    display: inline-block;
    width: 30px;
    height: 50px;
    font-size: 24px;
    text-align: center;
    color: white;
    vertical-align: middle;
    border-radius: 5px;
    &:nth-of-type(1) {
      margin-right: 4px;
    }
    &:hover {
      box-shadow: 3px 3px 6px #555;
    }
  }
  .placeholder {
    display: inline-block;
    width: 30px;
    height: 50px;
    font-size: 24px;
    text-align: center;
    color: white;
    vertical-align: middle;
    border-radius: 5px;
    &:nth-of-type(1) {
      margin-right: 4px;
    }
    &:hover {
      box-shadow: 3px 3px 6px transparent;
    }
  }
  .room {
    margin-bottom: 5px;
    cursor: pointer;
    &:hover {
      box-shadow: 3px 3px 6px rgb(39, 38, 38);
    }
  }
  .user-icon {
    &:hover {
      text-shadow: 2px 2px 4px #fff;
    }
  }
}
</style>
